import declare from "dojo/_base/declare";
import enums from "csi/enums";
import Widget from "csi/form/Widget";
import { Field } from "csi/def/Field";


const ITEM_TYPE_FIELD: string = "ItemType";

const EC_PURPOSE_ENGINEERING_CHANGE: string =  "ECPurpose:EngineeringChange";

const EC_ITEM_TYPE_FOOD: string = "ECItemType:Food";
const EC_ITEM_TYPE_FORMULATED_MATERIAL: string = "ECItemType:FormulatedMaterial";
const EC_ITEM_TYPE_FOOD_INGREDIENT: string = "ECItemType:FoodIngredient";

const EC_ITEM_TYPE_FORMULATED_PRODUCT_SET: Set<string> = new Set([
	EC_ITEM_TYPE_FOOD, 
	EC_ITEM_TYPE_FOOD_INGREDIENT, 
	EC_ITEM_TYPE_FORMULATED_MATERIAL,
]);

const NewAffectedItemForm = declare(Widget, {

	/**
     * @override
     * Remove Formulated Product enums from FilterType dropdown
     */
	getFieldStore: function(field: Field, value: string): any {
		const formContext = this.getFormContext();
		const nodeParent = formContext.getNodeParent();
		const purpose = nodeParent.Purpose;
        
		if (field.getControlName() === ITEM_TYPE_FIELD) {
			if (purpose === EC_PURPOSE_ENGINEERING_CHANGE) {
				return enums.getStore(field.getEnumId(), null, (value) => !EC_ITEM_TYPE_FORMULATED_PRODUCT_SET.has(value));
			} else {
				return enums.getStore(field.getEnumId(), null, (value) => EC_ITEM_TYPE_FORMULATED_PRODUCT_SET.has(value));
			}
		}
		return this.inherited(arguments);
	},

});

export = NewAffectedItemForm;